import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { Link } from '@router/Link';

import AllIcon from './AllIcon';
import styles from './styles.module.scss';

function AllButton() {
  return (
        <Link activityName='OrderLogsActivity'
              activityParams={{ duration: 'WEEK' }}>
            <Column align='center' spacing={6}
                    className={styles.container}>
                <AllIcon/>
                <div className={styles.text}>
                    <Text color={colors.white}>
                        전체보기
                    </Text>
                </div>
            </Column>
        </Link>
  );
}

export default AllButton;
